import React, { useCallback } from 'react';
import { RouteComponentProps } from 'react-router';

import useVehicle from 'core/hooks/useVehicle';
import { VehicleFormSchema } from 'core/schemas/vehicleForm';
import { FormSubmitHandler } from 'Elements/Form';

import VehicleForm from './VehiclePage/VehicleForm';
import VehiclePage from './VehiclePage/VehiclePage';

type Props = RouteComponentProps<{ id: string }>;

export default function VehicleDetail({ match }: Props) {
  const { vehicle, update } = useVehicle(+match.params.id);

  const onSubmit: FormSubmitHandler<VehicleFormSchema> = useCallback(
    (values, form) => {
      return update(values.vehicle).catch(errors =>
        form.setErrors({ vehicle: errors })
      );
    },
    [update]
  );

  return (
    <VehicleForm onSubmit={onSubmit} vehicle={vehicle} id={+match.params.id}>
      <VehiclePage
        title={vehicle ? vehicle.reg : '–'}
        subtitle={vehicle ? vehicle.identifier : '–'}
      />
    </VehicleForm>
  );
}
